/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type ZerogStorageSubmissionsDetailInfo = {
    SEQ: string;
    FHA: string;
    FSTAT: ZerogStorageSubmissionsDetailInfo.FSTAT;
    ADDR: EvmAddressSummaryInfo;
    SI: string;
    BF: string;
    BFVAL: string;
    STPO: string;
    ENDPO: string;
    SEG: string;
    BNO: string;
    TRXHA: string;
    TRXF: string;
    TRXFVAL: string;
    GU: string;
    GUP: string;
    GW: string;
    AG: string;
    UT: number;
};

export namespace ZerogStorageSubmissionsDetailInfo {

    export enum FSTAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

